
/**
 * Configuração de Anúncios e Informativos T-SERVI
 * O sistema rotaciona automaticamente os itens a cada 15 segundos.
 */

export const SIDEBAR_ADS = {
    // LADO ESQUERDO: Focado em Dicas e Educação do Usuário (Links vazios)
    left: [
        {
            id: 101,
            title: "DICA DO DIA",
            description: "Um trabalho bem feito merece sua avaliação!",
            imageUrl: "https://images.unsplash.com/photo-1557426272-fc759fdf7a8d?w=400&q=80",
            link: "",
            color: "text-blue-600"
        },
        {
            id: 102,
            title: "DICA DE SEGURANÇA",
            description: "Mantenha sempre seu perfil com fotos reais dos seus serviços.",
            imageUrl: "https://images.unsplash.com/photo-1557804506-669a67965ba0?w=400&q=80",
            link: "",
            color: "text-red-600"
        },
        {
            id: 103,
            title: "ANUNCIE SEU SERVIÇO",
            description: "Escale seu negócio com a T-SERVI.",
            imageUrl: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=400&q=80",
            link: "/servi/academy",
            color: "text-emerald-600"
        },
        {
            id: 104,
            title: "DICA DO DIA",
            description: "Verifique as avaliações antes de solicitar um profissional.",
            imageUrl: "https://images.unsplash.com/photo-1521791136064-7986c2923216?w=400&q=80",
            link: "",
            color: "text-blue-600"
        },
        {
            id: 105,
            title: "DICA DE SEGURANÇA",
            description: "Confira os itens descritos nos orçamentos antes de aceitá-los.",
            imageUrl: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=400&q=80",
            link: "",
            color: "text-red-600"
        },
        {
            id: 106,
            title: "ANUNCIE SEU SERVIÇO",
            description: "Complete seu perfil para aumentar sua visibilidade.",
            imageUrl: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&q=80",
            link: "/profile",
            color: "text-emerald-600"
        }
    ],
    // LADO DIREITO: Focado em Parceiros e Venda de Espaço
    right: [
        {
            id: 201,
            title: "T-SERVI OFICIAL",
            description: "Conheça as vantagens de ser um profissional verificado.",
            imageUrl: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=400&q=80",
            link: "/servi/academy",
            color: "text-blue-900"
        },
        {
            id: 202,
            title: "ANUNCIE AQUI",
            description: "Seja um parceiro T-SERVI e alcance milhares de profissionais e clientes.",
            imageUrl: "https://images.unsplash.com/photo-1559136555-9303baea8ebd?w=400&q=80",
            link: "https://t-servi.app.br/contato", // Ajuste conforme seu link de contato
            color: "text-slate-500"
        },
        {
            id: 203,
            title: "PARCEIRO T-SERVI",
            description: "Descontos exclusivos em ferramentas para nossos prestadores.",
            imageUrl: "https://images.unsplash.com/photo-1530124560676-b0713ee6d4f4?w=400&q=80",
            link: "#",
            color: "text-orange-600"
        }
    ]
};
